'use client';

import classNames from 'classnames';
import { SharedCtaComponent } from '@sapientpro/sapientpro-data-models';
import { SyntheticEvent } from 'react';
import { useSetAtom } from 'jotai';
import styles from './ShortCTA.module.scss';
import AnimatedTitle from '../../../components/AnimatedTitle';
import Button, { ButtonVariants } from '../../../components/Button';
import contactModalTriggerButton from '../../../store/contactForm';

const ShortCTA = ({
  data,
}: {
  data: SharedCtaComponent;
}) => {
  const setContactsModalTrigger = useSetAtom(contactModalTriggerButton);

  const handleGetExpertAdviceClick = (event: SyntheticEvent) => {
    setContactsModalTrigger(`${(event.target as HTMLElement).innerText} | pos terminal landing page cta section`);
  };

  return (
    <section className={classNames(styles.shortCTAWrapper, 'container')}>
      <div className={styles.shortCTA}>
        <div className={styles.shortCTA__content}>
          <h2 className={styles.shortCTA__title}>
            <AnimatedTitle title={data.title} />
          </h2>
          <Button
            variant={ButtonVariants.PRIMARY}
            className={styles.shortCTA__button}
            onClick={handleGetExpertAdviceClick}
          >
            {data.ctaButton}
          </Button>
        </div>
        <div className={styles.shortCTA__imageWrapper}>
          <img
            src={data.image.url}
            alt={data.image.caption ?? 'CTA'}
            className={styles.shortCTA__image}
          />
        </div>
      </div>
    </section>
  );
};

export default ShortCTA;
